// ##### Komarov 2025-07-23
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText.js';
// ##### 25-05-21 Komarov
import PromoCode from '../HotelsAutocompleteBlock/PromoCode';

// ##### Komarov 2025-08-05
const BorderInnerWrapper2DivTag = ({ width = 'unset', addToList }) => {
  const Search = useLocalizedText('Search');

  return (
    <div
      data-component="BorderInnerWrapper2DivTag"
      // ##### 23-11-02 Komarov
      className="borderInnerWrapper2"
    >
      <div
        style={{
          display: 'flex',
          width,
        }}
      >
        <div className="promocode_mobile">
          {/* ##### 24-08-05 Komarov */}
          {/* TODO: Исправить код с учтётом различия понятий refpartner и promoCode */}
          <PromoCode /* refpartner={searchProps ? searchProps.refpartner : ""} */
          />
        </div>

        <button type="submit" onClick={addToList}>
          {
            // ##### 23-10-04 Komarov
            Search
          }
        </button>
      </div>
    </div>
  );
};

export default BorderInnerWrapper2DivTag;
